var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTickLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.84 27.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0c0c0c;}.cls-2{fill:#9ca5ad;}.cls-3{fill:none;stroke:#9ca5ad;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vectors"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 13.92,
    cy: 13.92,
    r: 12.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.92,27.84A13.92,13.92,0,1,1,27.84,13.92,13.93,13.93,0,0,1,13.92,27.84Zm0-25.7A11.78,11.78,0,1,0,25.7,13.92,11.8,11.8,0,0,0,13.92,2.14Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "7.84 14.07 12.39 17.93 18.9 10.2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickLight);
export default __webpack_public_path__ + "static/media/tick_light.7a83c552dfc123ef4d5055e0a59a315d.svg";
export { ForwardRef as ReactComponent };